import type { tCloseType } from './LeadClose.types';

/** The caps leads-service enforces (LeadCloseFields, Money), so the form and the server agree. */
export const CLOSE_MAX_WHAT_SOLD = 255;
export const CLOSE_MAX_OTHER_TEXT = 80;
export const CLOSE_MAX_NOTE = 2000;
export const CLOSE_MAX_INTEGER_DIGITS = 12;

/** "Archivar lead" starts checked only for Perdido (Appendix A). */
export const CLOSE_ARCHIVE_DEFAULT: Record<tCloseType, boolean> = {
  sold: false,
  lost: true,
  resolved: false,
};

export const LEAD_CLOSE_FLAG = 'leads_lead-close';

/**
 * Every reason the form explains: its own checks and the refusals of
 * leads-service and bff-web. Any other reason reads as `unavailable`.
 */
export const CLOSE_ERROR_REASONS = [
  'amount_required',
  'amount_not_positive',
  'amount_decimals',
  'amount_too_large',
  'amount_invalid',
  'reason_required',
  'what_sold_too_long',
  'other_text_too_long',
  'note_too_long',
  'prior_choice_required',
  'currency_not_allowed',
  'currency_locked',
  'currency_unsupported',
  'option_unavailable',
  'other_not_allowed',
  'prior_amount_changed',
  'prior_amount_invalid',
  'sale_date_invalid',
  'idempotency_conflict',
  'revision_conflict',
  'result_deleted',
  'type_immutable',
  'settings_unavailable',
  'forbidden',
  'not_found',
  'membership_required',
  'too_many_requests',
  'unavailable',
] as const;
